import React from "react";
import PropTypes from "prop-types";

const RequestNoActive = ({ request, shiftHours, subHoursThisWeek }) => (
  <tr>
    <th>Sub Name</th>
    <td>
      {request.sub_full_name ? (
        <a href={`/users/${request.sub_user_id}`} className="styled-link">
          {request.sub_full_name}
        </a>
      ) : (
        <span>
          EMPLOYEE NOT FOUND
        </span>
      )}
      &nbsp;
      {!request.active && !request.processed ? (
        <span className="grey-text">
          <i className="glyphicon glyphicon-time" /> {subHoursThisWeek} Hours&nbsp;
          <i className="glyphicon glyphicon-arrow-right" />&nbsp;
          <i className="glyphicon glyphicon-time" />&nbsp;
          {subHoursThisWeek + shiftHours} Hours
        </span>
      ) : null}
    </td>
  </tr>
);

RequestNoActive.propTypes = {
  request: PropTypes.object.isRequired,
  shiftHours: PropTypes.number.isRequired,
  subHoursThisWeek: PropTypes.number.isRequired
};

RequestNoActive.defaultProps = {
  shiftHours: 0,
  subHoursThisWeek: 0
};

export default RequestNoActive;
